import { config } from "@repo/config";
import {
	TeamSettings,
	TeamSettingsSkeleton,
} from "@saas/organizations/components/TeamSettings";
import { organizationsQueryKeys } from "@saas/organizations/lib/api";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { ClientOnly, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/members",
)({
	loader: ({ context }) => {
		// The org route already loaded the full organization (members and
		// invitations): seed the cache the team list reads from.
		const queryClient = getServerQueryClient();
		queryClient.setQueryData(
			organizationsQueryKeys.detail(context.organization.id),
			context.organization,
		);
		return {
			organizationId: context.organization.id,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({ meta: [{ title: `Team - ${config.appName}` }] }),
	component: OrganizationMembersPage,
});

function OrganizationMembersPage() {
	const { organizationId, dehydratedState } = Route.useLoaderData();
	// Members and roles load through the Better Auth client, which only has
	// the session cookie in the browser: rendering on the server always 401s.
	return (
		<ClientOnly fallback={<TeamSettingsSkeleton />}>
			<AsyncBoundary
				fallback={<TeamSettingsSkeleton />}
				dehydratedState={dehydratedState}
				errorFallback="inline"
			>
				<TeamSettings organizationId={organizationId} />
			</AsyncBoundary>
		</ClientOnly>
	);
}
